<template>
  <div class="main">
    <div class="person">
        <div class="pinner">
          <img src="../assets/page01_person.png" alt="人物" srcset="">
          <img src="../assets/page01-txt.png" class="ptxt" />
          <div class="disk">
            <img src="../assets/page01_disk-l.png" alt="disk-left" class="diskl" :class="[isVisible ? 'invisible' : '']">
            <img src="../assets/page01_disk-r.png" alt="disk-right" class="diskr" :class="[isVisible ? 'invisible' : '']">
          </div>
        </div>
      </div>
    <img src="../assets/page01_aside.png" alt="案例" srcset="" class="sample">

    <span v-on:click="go">
      <img src="../assets/page01_button.png" alt="button" class="btn-img">
    </span>
    <audio id="music" :src="musicsrc" preload="preload" loop="loop"></audio>
    <page-three :isVisible="isVisible" />
  </div>
</template>

<script>
import axios from 'axios'
import { setItem } from '../utils/store.js'
import Pg3 from './Pg3'

let fun1
export default {
  name: 'Pg1',
  components: {
    'page-three': Pg3
  },
  data () {
    return {
      isVisible: false,
      musicsrc:'https://www.h5anli.com/wxactivities/yao/5018.mp3',
      isflag:true,
      lastUpdate:0,
      x:0,
      y:0,
      z:0,
      lastx:0,
      lasty:0,
      lastz:0,
      SHAKE_THRESHOLD:8000
    }
  },
  methods: {
    go () {
      //this.isbindyao++
      let to
      let isFilled
      if (window.localStorage) {
        isFilled = Object.keys(localStorage).some((item) => /\d{13}/.test(item))
        to = isFilled === true ? 'pg4' : 'pg2'
      } else {
        //alert('localstorage unsupported')
      }
      this.$router.push(to)
    },
    toggle () {
      this.isVisible = !this.isVisible
    },
    recordinfo(){
      if(!this.isflag) return
      this.isflag=false;


      const URL = 'https://www.h5anli.com'
      const fetchApi = `/h5share.php/Home/Loveread/JDOU_randomone/`
      let data
      let nexturl

      axios.post(fetchApi)
        .then(function (response) {
          nexturl = response.data.data.h5url
          data = response.data.data
          setItem(data)
          window.location = `${URL}${nexturl}`
        })
        .catch(function (err) {
          console.error(err)
        })
    },
    audioPlay () {
        var audio = document.getElementById('music');
        audio.play();
        document.addEventListener("WeixinJSBridgeReady", function () {
                audio.play();
        }, false);
    },
    deviceMotionHandler (eventData) {

      var acceleration = eventData.accelerationIncludingGravity
      var curTime = new Date().getTime()

      if ((curTime - this.lastUpdate) > 300) {
        var diffTime = parseInt(curTime - this.lastUpdate)
        this.lastUpdate = curTime
        this.x = acceleration.x
        this.y = acceleration.y
        this.z = acceleration.z
        var speed = Math.abs(this.x + this.y + this.z - this.lastx - this.lasty - this.lastz) / diffTime * 10000

        if (speed > this.SHAKE_THRESHOLD) {
          setTimeout(() => {
            this.recordinfo()
            this.isVisible = true
          }, 200);
          this.audioPlay()
        }
        this.lastx = this.x
        this.lasty = this.y
        this.lastz = this.z
      }
    }
  },
  mounted: function () {
    const audio = document.getElementById('music');
    audio.play();
    document.addEventListener("WeixinJSBridgeReady", function () {
            audio.play();
    }, false);

    setTimeout(function(){
      audio.pause();
      document.addEventListener("WeixinJSBridgeReady", function () {
              audio.pause();
      }, false);
    },20);

    let isWXApp = false;
    console.log(window.__wxjs_environment === 'miniprogram');
    isWXApp = window.__wxjs_environment === 'miniprogram';
    if (navigator.userAgent.indexOf('iPhone') > -1) {
      this.SHAKE_THRESHOLD = isWXApp ? 600 : 600
    } else if (navigator.userAgent.indexOf('QQ') > -1) {
      this.SHAKE_THRESHOLD = isWXApp ? 500 : 1000
    } else {
      this.SHAKE_THRESHOLD = isWXApp ? 1000 : 1200
    }

    if (window.DeviceMotionEvent) {
        window.addEventListener('devicemotion', this.deviceMotionHandler, false)
    }
  },
  destroyed () {
    window.removeEventListener('devicemotion', this.deviceMotionHandler, false)
  }
}
</script>

<style lang="less" scoped>
  .main {
    background-color: #f8f8f8;
    width: 100vw;
    height: 100vh;
    position: relative;
    z-index: 1;
  }

  .person {
    position: absolute;
    left: 11.9333vw;
    top: 20vh;
    width: 75vw;
    /* animation: shine 2s cubic-bezier(.31, .88, .31, .1) infinite;
    -webkit-animation: shine 2s cubic-bezier(.31, .88, .31, .1) infinite; */
    .pinner{
      width: 100%;
      height: 100%;
      position: relative;
    }
    img {
      width: 100%;
    }
    .diskl {
      position: absolute;
      width: 20vw;
      top: 70.4%;
      left: 9.8%;
      z-index: 2;
      animation: circle 1.5s infinite;
      -webkit-animation: circle 1.5s infinite;
    }

    .diskr {
      position: absolute;
      width: 16vw;
      top: 69.9%;
      right: 10%;
      z-index: 2;
      animation: circler 1.5s infinite;
      -webkit-animation: circler 1.5s infinite;
    }

    .ptxt{
      position: absolute;
      width: 48vw;
      top: 5%;
      left: 0%;
      z-index: 2;
      animation: zyao 1s infinite;
      transform-origin: 100% 80%;
    }
  }
  .sample {
    position: absolute;
    left: 0;
    top: 4.4vh;
    width: 35.2vw;
  }

  .btn-img {
    position: absolute;
    bottom: 9vh;
    /* display: block; */
    left: 20vw;
    width: 60.4vw;
  }

  .invisible {
    display: none;
    visibility: hidden;
  }



  @keyframes circle {
    0% {
      transform: rotate(0);
    }

    25% {
      transform: rotate3d(1.5, 2.0, 1.8, 10deg);
    }

    50% {
      transform: rotate(0);
    }

    70% {
      transform: rotate3d(1.5, 2.0, 1.8, 10deg);
    }
  }

  @-webkit-keyframes circle {
    0% {
      transform: rotate(0);
    }

    25% {
      transform: rotate3d(1.5, 2.0, 1.8, 10deg);
    }

    50% {
      transform: rotate(0);
    }

    70% {
      transform: rotate3d(1.5, 2.0, 1.8, 10deg);
    }
  }

  @keyframes circler {
    0% {
      transform: rotate(0);
    }

    25% {
      transform: rotate3d(1.5, 2.0, 3.0, -6deg);
    }

    50% {
      transform: rotate(0);
    }

    70% {
      transform: rotate3d(1.5, 2.0, 3.0, -6deg);
    }
  }

  @-webkit-keyframes circler {
    0% {
      transform: rotate(0);
    }

    25% {
      transform: rotate3d(1.5, 2.0, 3.0, -6deg);
    }

    50% {
      transform: rotate(0);
    }

    70% {
      transform: rotate3d(1.5, 2.0, 3.0, -6deg);
    }
  }

  @keyframes zyao{
    0%{transform: rotate(-5deg)}
    50%{transform: rotate(5deg)}
    100%{transform: rotate(-5deg)}
  }

  /* @keyframes shine {
    0% {
      transform: scale3d(1, 1, 1);
    }
    5% {
      transform: scale3d(1.05, 1.05, 1.05);
    }
    15% {
      transform: scale3d(1, 1, 1);
    }
    20% {
      transform: scale3d(1.05, 1.05, 1.3);
    }
    30% {
      transform: scale3d(1, 1, 1);
    }
  }
  @-webkit-keyframes shine {
    0% {
      transform: scale3d(1, 1, 1);
    }
    5% {
      transform: scale3d(1.05, 1.05, 1.05);
    }
    15% {
      transform: scale3d(1, 1, 1);
    }
    20% {
      transform: scale3d(1.05, 1.05, 1.3);
    }
    30% {
      transform: scale3d(1, 1, 1);
    }
  } */

</style>



// WEBPACK FOOTER //
// src/components/Pg1.vue